<div class="overlay-container">
  <h2 class="title">We are working to save your changes ...</h2>
  <div aria-label="hamster running in a wheel" role="img" class="wheel-and-hamster">
    <div class="wheel"></div>
     <div class="hamster">
        <div class="hamster__body">
            <div class="hamster__head">
                <div class="hamster__ear"></div>
                <div class="hamster__eye"></div>
                <div class="hamster__nose"></div>
            </div>
            <div class="hamster__limb hamster__limb--fr"></div>
            <div class="hamster__limb hamster__limb--fl"></div>
            <div class="hamster__limb hamster__limb--br"></div>
            <div class="hamster__limb hamster__limb--bl"></div>
            <div class="hamster__tail"></div>
        </div>
    </div> 
    <div class="spoke"></div>
  </div>
</div>
